/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-05-09 19:00:07
 */
import request from '@api/request'
// 校验是否能认证普通机构或者服务机构
export const checkSetting = params => request.get('/entIntermediary/checkSetting', { params })

// 查看企业认证状态
export const checkStatus = params => request.get('/entIntermediary/checkStatus', { params })

// 服务类型字典表
export const serviceTypeDic = params => request.get('/entIntermediary/serviceTypeDic', { params })

// 普通机构详情 （old：/entIntermediary/entIntermediaryDetail）
export const entIntermediaryDetail = params => request.get('/entEntCommonIntermediary/entIntermediaryDetail', { params })
// 服务机构详情
export const entIntermediaryDetail1 = params => request.get('/entIntermediary/entIntermediaryDetail1', { params })
// 企业提交认证 （old：/entIntermediary/submitAuthen ）
export const submitAuthen = params => request.post('/entEntCommonIntermediary/submitAuthen', params)

// 企业服务券机构提交认证
export const submitServerAuthen = params => request.post('/entIntermediary/submitServerAuthen', params)

// 图片上传
export const uploadFileByContentType = params => request.upload(process.env.VUE_APP_BASE_API + process.env.VUE_APP_REQUEST_PREFIX3 + '/api/file/upload', params)

// 服务类型
export const entDictList = params => request.get('/lishui-qym-ent/qymEntGoods/entDictList', { params })

// 服务类型字典表 日鑫
export const serviceTypeDicRx = params => request('/lishui-gov/govEntIntermediary/serviceTypeDic', { params })

